import { render } from "./AVDA_import_photos.vue?vue&type=template&id=3f094ca5&scoped=true"
import script from "./AVDA_import_photos.vue?vue&type=script&lang=js"
export * from "./AVDA_import_photos.vue?vue&type=script&lang=js"

import "./AVDA_import_photos.vue?vue&type=style&index=0&id=3f094ca5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f094ca5"]])

export default __exports__